import { subscriptionFragment } from '../user-subscription/user-subscription.fragment'

export const getUserQuery = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      createdAt
      name
      email
      phone
      company
      SIRET
      VAT
      type
      access
      address
      city
      zipcode
      country
      language
      shop(filter: { organizationID: { attributeExists: false } }) {
        items {
          id
          enabled
          enablePassword
        }
      }
      organizations(
        limit: 10000
        filter: {
          type: { ne: "PROJECT" }
          or: [{ status: { eq: "DONE" } }, { status: { eq: "PENDING" } }]
        }
      ) {
        items {
          id
          organizationID
          role
          status
          onSeat
          seatAccessState
          seatGraceEndsAt
          organization {
            name
            color
            status
            logo
            masterID
            parentID
            isMaster
            partner
          }
        }
      }
      subscriptions(sortDirection: DESC, limit: 1000) {
        items {
          ...subscriptionData
        }
        nextToken
      }
      preferences {
        key
        values
      }
    }
  }
  ${subscriptionFragment}
`

export const userSessionByUserQuery = /* GraphQL */ `
  query UserSessionByUser($userID: ID!) {
    userSessionByUser(userID: $userID, sortDirection: DESC, limit: 10) {
      items {
        id
        createdAt
        newDevice
      }
    }
  }
`

export const getLightUserQuery = /* GraphQL */ `
  query GetLightUser($id: ID!) {
    getUser(id: $id) {
      id
      name
      email
    }
  }
`

export const updateUserQuery = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      updatedAt
    }
  }
`

export const organizationMemberbyEmail = /* GraphQL */ `
  query OrganizationMemberbyEmail(
    $email: String!
    $status: ModelStringKeyConditionInput
  ) {
    organizationMemberbyEmail(email: $email, status: $status) {
      items {
        id
        userID
        status
      }
    }
  }
`

export const userByEmailQuery = /* GraphQL */ `
  query UserByEmail($email: String!, $filter: ModelUserFilterInput) {
    userByEmail(email: $email, filter: $filter) {
      items {
        id
        name
      }
    }
  }
`
